import { AppState } from "../rootReducer";

export const getAccessToken = (state: AppState) => state.token.accessToken;

export const getRefreshTokenExpiresAt = (state: AppState) => state.token.expiresAt;